var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"md":"12"}},[(_vm.selectedOrganization.seller && _vm.$can('TRIP_ACCOUNTING_VIEW'))?_c('dashboard-seller-informations'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }